module.exports = __webpack_public_path__ + "2d8712b07aea823ddaf551da0a8810ea.jpg";